const manualCities = [
  {
    name: 'Agra, India',
    lat: 27.1767,
    lng: 78.0081,
    summary: 'Agra is home to the iconic Taj Mahal and other Mughal-era landmarks like Agra Fort and Fatehpur Sikri. A must-visit for history and architecture lovers.',
  },
  {
    name: 'Manali, India',
    lat: 32.2432,
    lng: 77.1892,
    summary: 'Manali is a popular hill station nestled in the Himalayas, known for snow-capped peaks, adventure sports, and scenic valleys.',
  },
  {
    name: 'Paris, France',
    lat: 48.8566,
    lng: 2.3522,
    summary: 'Paris is the capital of France, known for the Eiffel Tower, romantic vibes, art museums like the Louvre, and exquisite food and fashion.',
  },
  {
    name: 'Jaipur, India',
    lat: 26.9124,
    lng: 75.7873,
    summary: 'Jaipur, the Pink City, offers royal palaces, colorful bazaars, and historic forts such as Amer Fort and City Palace.',
  },
  {
    name: 'Goa, India',
    lat: 15.2993,
    lng: 74.1240,
    summary: 'Goa is India’s party capital, famous for its beaches, nightlife, Portuguese heritage, and relaxed coastal vibes.',
  },
  {
    name: 'Rishikesh, India',
    lat: 30.0869,
    lng: 78.2676,
    summary: 'Rishikesh is a spiritual town on the banks of the Ganges, known for yoga, meditation, and adventure activities like river rafting.',
  },
  {
    name: 'Mysore, India',
    lat: 12.2958,
    lng: 76.6394,
    summary: 'Mysore is known for the grand Mysore Palace, Dasara Festival, and its cultural richness in arts and yoga.',
  },
  {
    name: 'Kodaikanal, India',
    lat: 10.2381,
    lng: 77.4892,
    summary: 'Kodaikanal is a serene hill station in Tamil Nadu, famous for its lake, pine forests, and misty landscapes.',
  },
  {
    name: 'Udaipur, India',
    lat: 24.5854,
    lng: 73.7125,
    summary: 'Udaipur, the City of Lakes, boasts romantic palaces, heritage hotels, and picturesque lakes like Pichola and Fateh Sagar.',
  },
  {
    name: 'Kolkata, India',
    lat: 22.5726,
    lng: 88.3639,
    summary: 'Kolkata, the City of Joy, blends colonial charm with modern life. Known for Durga Puja, street food, art, and culture.',
  },
  {
    name: 'Munnar, India',
    lat: 10.0889,
    lng: 77.0595,
    summary: 'Munnar is a tranquil hill station in Kerala, famous for lush tea gardens, cool climate, and wildlife sanctuaries.',
  },
  {
    name: 'Darjeeling, India',
    lat: 27.0360,
    lng: 88.2627,
    summary: 'Darjeeling is a charming hill town in West Bengal, offering panoramic views of the Himalayas, toy trains, and tea estates.',
  },
  {
    name: 'Jodhpur, India',
    lat: 26.2389,
    lng: 73.0243,
    summary: 'Jodhpur, the Blue City, is known for the majestic Mehrangarh Fort, blue-painted houses, and desert charm.',
  },
  {
    name: 'Andaman Islands, India',
    lat: 11.7401,
    lng: 92.6586,
    summary: 'The Andaman Islands are a tropical paradise with white-sand beaches, coral reefs, scuba diving, and a relaxed island vibe.',
  },
  {
    name: 'Alleppey, India',
    lat: 9.4981,
    lng: 76.3388,
    summary: 'Alleppey is known for its scenic backwaters, houseboat cruises, and tranquil views of Kerala’s waterways and paddy fields.',
  },
  {
    name: 'Shillong, India',
    lat: 25.5788,
    lng: 91.8933,
    summary: 'Shillong, the Scotland of the East, offers green hills, waterfalls, colonial architecture, and music festivals.',
  },
  {
    name: 'Pondicherry, India',
    lat: 11.9416,
    lng: 79.8083,
    summary: 'Pondicherry blends French colonial charm with Indian culture. Known for clean beaches, Auroville, and relaxed vibes.',
  },
  {
    name: 'Ranthambore, India',
    lat: 26.0173,
    lng: 76.5026,
    summary: 'Ranthambore is a top wildlife destination in Rajasthan, known for tiger safaris and the ancient Ranthambore Fort.',
  },
  {
    name: 'Coorg, India',
    lat: 12.3375,
    lng: 75.8069,
    summary: 'Coorg is a lush coffee region in Karnataka, known for green hills, waterfalls, and a peaceful climate.',
  },
  {
    name: 'Auli, India',
    lat: 30.5286,
    lng: 79.5666,
    summary: 'Auli is a Himalayan ski resort town in Uttarakhand, popular for snow sports and stunning mountain views.',
  },
  {
    name: 'Lonavala, India',
    lat: 18.7500,
    lng: 73.4167,
    summary: 'Lonavala is a quick getaway from Mumbai and Pune, known for waterfalls, greenery, and monsoon beauty.',
  },
  {
    name: 'Hampi, India',
    lat: 15.3350,
    lng: 76.4600,
    summary: 'Hampi is a UNESCO World Heritage site with stunning ruins from the Vijayanagara Empire surrounded by surreal landscapes.',
  },
  {
    name: 'Tarkarli, India',
    lat: 16.0396,
    lng: 73.4982,
    summary: 'Tarkarli is a serene beach town in Maharashtra, perfect for scuba diving, snorkeling, and clean, peaceful beaches.',
  },
  {
    name: 'Cherrapunji, India',
    lat: 25.2843,
    lng: 91.7308,
    summary: 'Cherrapunji is one of the wettest places on Earth, famous for its waterfalls, root bridges, and lush terrain.',
  },
  {
    name: 'Rameswaram, India',
    lat: 9.2876,
    lng: 79.3129,
    summary: 'Rameswaram is a spiritual coastal town in Tamil Nadu, known for temples and the scenic Pamban Bridge.',
  },
  {
    name: 'Ziro Valley, India',
    lat: 27.5622,
    lng: 93.8328,
    summary: 'Ziro Valley in Arunachal Pradesh is a quiet paradise of pine forests, paddy fields, and Apatani tribal culture.',
  },
  {
    name: 'Tawang, India',
    lat: 27.5860,
    lng: 91.8662,
    summary: 'Tawang is a scenic hill town in Arunachal Pradesh, home to one of the largest Buddhist monasteries in India.',
  },
  {
    name: 'Mahabalipuram, India',
    lat: 12.6170,
    lng: 80.1976,
    summary: 'Mahabalipuram is a coastal town famous for its ancient rock-cut temples and monuments, a UNESCO site.',
  },
  {
    name: 'Spiti Valley, India',
    lat: 32.2464,
    lng: 78.0170,
    summary: 'Spiti Valley is a high-altitude desert in Himachal Pradesh, ideal for offbeat travel and Buddhist monasteries.',
  },
  {
    name: 'Dharamshala, India',
    lat: 32.2190,
    lng: 76.3234,
    summary: 'Dharamshala is the home of the Dalai Lama and offers a blend of Tibetan culture, scenic treks, and peaceful monasteries.',
  },
  {
  name: "Mathura, India",
  lat: 27.4924,
  lng: 77.6737,
  summary: "Mathura is the birthplace of Lord Krishna and a major pilgrimage site. It's famous for its vibrant Holi celebrations, temples, and spiritual atmosphere."
},
{
  name: "Vrindavan, India",
  lat: 27.5743,
  lng: 77.6985,
  summary: "Vrindavan is a holy town associated with Lord Krishna, filled with ancient temples, spiritual music, and the energy of devotion. A must-visit for seekers of peace."
},
{
  name: "Bodh Gaya, India",
  lat: 24.6951,
  lng: 84.9912,
  summary: "Bodh Gaya is one of the most important Buddhist pilgrimage sites in the world. It’s where Gautama Buddha attained enlightenment under the Bodhi Tree."
},
{
  name: "Hampi, India",
  lat: 15.335,
  lng: 76.4601,
  summary: "Hampi is a UNESCO World Heritage Site, home to ancient ruins, temples, and bouldered landscapes — a surreal blend of history and nature."
},
{
  name: "Pondicherry, India",
  lat: 11.9139,
  lng: 79.8145,
  summary: "Pondicherry is a serene coastal town with French colonial charm, quiet beaches, spiritual centers, and colorful architecture."
},
{
  name: "Kanha National Park, India",
  lat: 22.3344,
  lng: 80.6115,
  summary: "Kanha National Park in Madhya Pradesh is one of India’s top tiger reserves. It offers amazing wildlife safari experiences and lush forest landscapes."
},
{
  name: "Kaziranga National Park, India",
  lat: 26.5775,
  lng: 93.1711,
  summary: "Kaziranga is a UNESCO-listed national park in Assam, famous for its one-horned rhinoceroses, rich biodiversity, and thrilling jeep safaris."
},
{
  name: "Mahabalipuram, India",
  lat: 12.617,
  lng: 80.197,
  summary: "Mahabalipuram is a historical town in Tamil Nadu known for its rock-cut temples, shore temples, and ancient sculptures by the Pallava dynasty."
},
{
  name: "Kanchipuram, India",
  lat: 12.8342,
  lng: 79.7036,
  summary: "Kanchipuram is a temple city known as the ‘City of Thousand Temples’, and famous for its silk sarees, culture, and ancient architecture."
},
{
  name: "Spiti Valley, India",
  lat: 32.2465,
  lng: 78.0177,
  summary: "Spiti Valley is a remote, cold desert mountain valley in Himachal Pradesh. Known for monasteries, rugged terrain, and stunning landscapes."
},
{
  name: "Orchha, India",
  lat: 25.3516,
  lng: 78.6408,
  summary: "Orchha is a hidden gem in Madhya Pradesh with magnificent forts, temples, and a medieval charm that offers a step back in time."
},
{
  name: "Rishikesh, India",
  lat: 30.0869,
  lng: 78.2676,
  summary: "Rishikesh is the yoga capital of the world, nestled in the Himalayas by the Ganges. Perfect for spirituality, adventure, and scenic beauty."
},
{
  name: "Haridwar, India",
  lat: 29.9457,
  lng: 78.1642,
  summary: "Haridwar is an ancient city where the Ganga enters the plains. It’s famous for the Ganga Aarti, temples, and spiritual energy."
},
{
  name: "Ranakpur, India",
  lat: 25.1162,
  lng: 73.476,
  summary: "Ranakpur in Rajasthan is home to one of the most beautiful Jain temples in India, known for intricate marble architecture and serenity."
},
{
  name: "Tawang, India",
  lat: 27.5861,
  lng: 91.8687,
  summary: "Tawang in Arunachal Pradesh is a peaceful Buddhist town known for its stunning monastery, snow-capped mountains, and scenic beauty."
},
{
  name: "Chopta, India",
  lat: 30.4927,
  lng: 79.0671,
  summary: "Chopta is a small Himalayan village and the base for Tungnath trek. Known as the 'Mini Switzerland of India', it's a great spot for nature lovers."
},
{
  name: "Ziro, India",
  lat: 27.6015,
  lng: 93.8332,
  summary: "Ziro Valley in Arunachal Pradesh is a peaceful offbeat destination, famous for rice fields, tribal culture, and music festivals."
},
{
  name: "Gokarna, India",
  lat: 14.549,
  lng: 74.3187,
  summary: "Gokarna is a peaceful coastal town in Karnataka known for its pristine beaches, relaxed vibe, and spiritual temples. A great Goa alternative."
},
{
  name: "Chikmagalur, India",
  lat: 13.315,
  lng: 75.775,
  summary: "Chikmagalur is a coffee paradise in Karnataka, perfect for nature trails, plantations, waterfalls, and scenic hill retreats."
},
{
  name: "Patnitop, India",
  lat: 33.0807,
  lng: 75.3275,
  summary: "Patnitop is a beautiful hill station in Jammu known for panoramic views, snow in winter, and outdoor adventure like paragliding and trekking."
},
{
  name: "Alleppey, India",
  lat: 9.4981,
  lng: 76.3388,
  summary: "Alleppey, also known as Alappuzha, is famous for its backwaters, houseboat cruises, and serene views of coconut groves and paddy fields in Kerala."
},
{
  name: "Bundi, India",
  lat: 25.4305,
  lng: 75.6499,
  summary: "Bundi in Rajasthan is known for its blue houses, ornate palaces, stepwells, and a peaceful old-world charm away from the tourist crowds."
},
{
  name: "Diu, India",
  lat: 20.7141,
  lng: 70.9876,
  summary: "Diu is a small island known for Portuguese colonial architecture, serene beaches, historic forts, and a laid-back vibe."
},
{
  name: "Saputara, India",
  lat: 20.5792,
  lng: 73.7495,
  summary: "Saputara is a quaint hill station in Gujarat's Western Ghats known for lakes, gardens, tribal culture, and cool climate."
},
{
  name: "Majuli, India",
  lat: 26.9565,
  lng: 94.1459,
  summary: "Majuli is the world’s largest river island, located in the Brahmaputra River in Assam, known for its monasteries, art, and eco-friendly vibe."
},
{
  name: "Kumarakom, India",
  lat: 9.6172,
  lng: 76.431,
  summary: "Kumarakom is a peaceful village on Vembanad Lake in Kerala, popular for bird watching, luxurious backwater resorts, and boat rides."
},
{
  name: "Gwalior, India",
  lat: 26.2183,
  lng: 78.1828,
  summary: "Gwalior in Madhya Pradesh is rich in history, known for its hilltop fort, grand palaces, and classical music heritage."
},
{
  name: "Coonoor, India",
  lat: 11.3509,
  lng: 76.7955,
  summary: "Coonoor is a beautiful hill station in Tamil Nadu, surrounded by tea plantations, waterfalls, and colonial-era charm."
},
{
  name: "Halebidu, India",
  lat: 13.2172,
  lng: 75.994,
  summary: "Halebidu is an ancient town in Karnataka famous for its Hoysala-era temples, stunning stone carvings, and heritage significance."
},
{
  name: "Tarkarli, India",
  lat: 16.0396,
  lng: 73.4987,
  summary: "Tarkarli in Maharashtra is a hidden gem with pristine beaches, coral reefs, and water sports including snorkeling and scuba diving."
},
{
  name: "Lepakshi, India",
  lat: 13.8056,
  lng: 77.6067,
  summary: "Lepakshi in Andhra Pradesh is known for its incredible hanging pillar temple, ancient murals, and cultural heritage."
},
{
  name: "Murudeshwar, India",
  lat: 14.0946,
  lng: 74.484,
  summary: "Murudeshwar is famous for the world’s second tallest Shiva statue and its beachside temple perched on a hill by the sea."
},
{
  name: "Chitrakoot, India",
  lat: 25.2071,
  lng: 80.9014,
  summary: "Chitrakoot is a spiritual town with deep Ramayana connections, scenic waterfalls, and peaceful ghats on the Mandakini River."
},
{
  name: "Loktak Lake, India",
  lat: 24.5295,
  lng: 93.8277,
  summary: "Loktak Lake in Manipur is the largest freshwater lake in Northeast India, famous for its floating phumdis and the unique Keibul Lamjao National Park."
},
{
  name: "Champaner, India",
  lat: 22.4846,
  lng: 73.5331,
  summary: "Champaner is a historical city near Pavagadh Hill in Gujarat, known for its UNESCO-listed Islamic architecture and heritage fort."
},
{
  name: "Velankanni, India",
  lat: 10.6818,
  lng: 79.8497,
  summary: "Velankanni in Tamil Nadu is a coastal town known for the Basilica of Our Lady of Good Health, drawing Christian pilgrims from across India."
},
{
  name: "Chandipur, India",
  lat: 21.4702,
  lng: 87.0115,
  summary: "Chandipur in Odisha is famous for its disappearing beach, where the sea recedes dramatically, revealing the seabed."
},
{
  name: "Mawlynnong, India",
  lat: 25.2026,
  lng: 92.0015,
  summary: "Mawlynnong in Meghalaya is dubbed the ‘Cleanest Village in Asia’, known for its eco-friendly practices and lush beauty."
},
{
  name: "Tawang, India",
  lat: 27.5861,
  lng: 91.8687,
  summary: "Tawang in Arunachal Pradesh is a peaceful Buddhist town known for its stunning monastery, snow-capped mountains, and scenic beauty."
},
{
  name: "Pachmarhi, India",
  lat: 22.4671,
  lng: 78.4349,
  summary: "Pachmarhi is a scenic hill station in Madhya Pradesh with lush forests, waterfalls, caves, and colonial-era bungalows."
},
{
  name: "Alleppey, India",
  lat: 9.4981,
  lng: 76.3388,
  summary: "Alleppey, also known as Alappuzha, is famous for its backwaters, houseboat cruises, and serene views of coconut groves and paddy fields in Kerala."
},
{
  name: "Bundi, India",
  lat: 25.4305,
  lng: 75.6499,
  summary: "Bundi in Rajasthan is known for its blue houses, ornate palaces, stepwells, and old-world charm."
},
{
  name: "Kaziranga, India",
  lat: 26.5775,
  lng: 93.1711,
  summary: "Kaziranga National Park in Assam is a UNESCO World Heritage Site and home to the endangered one-horned rhinoceros."
},
{
  name: "Tawang, India",
  lat: 27.5860,
  lng: 91.8650,
  summary: "Tawang in Arunachal Pradesh is a serene mountain town known for its Buddhist monasteries and snowy Himalayan views."
},
{
  name: "Ziro, India",
  lat: 27.5946,
  lng: 93.8240,
  summary: "Ziro Valley in Arunachal Pradesh is an offbeat paradise with lush rice fields, tribal villages, and a popular music festival."
},
{
  name: "Rann of Kutch, India",
  lat: 23.7337,
  lng: 69.8597,
  summary: "The Rann of Kutch in Gujarat is a vast salt desert known for the Rann Utsav, white sand, and cultural experiences."
},
{
  name: "Chikmagalur, India",
  lat: 13.3153,
  lng: 75.7754,
  summary: "Chikmagalur in Karnataka is famous for its coffee plantations, scenic hills, and cool climate."
},
{
  name: "Patan, India",
  lat: 23.8500,
  lng: 72.1167,
  summary: "Patan in Gujarat is known for the UNESCO-listed Rani ki Vav stepwell and Patola silk sarees."
},
{
  name: "Yelagiri, India",
  lat: 12.5750,
  lng: 78.6333,
  summary: "Yelagiri in Tamil Nadu is a peaceful hill station perfect for trekking, nature walks, and weekend retreats."
},
{
  name: "Lepakshi, India",
  lat: 13.8046,
  lng: 77.6074,
  summary: "Lepakshi in Andhra Pradesh is a historical village famous for its hanging pillar and Vijayanagar-style temple carvings."
}, 
{
  name: "Gokarna, India",
  lat: 14.5500,
  lng: 74.3167,
  summary: "Gokarna in Karnataka is a laid-back beach town popular among backpackers for its serene beaches and spiritual vibe."
},
{
  name: "Hemis, India",
  lat: 33.8750,
  lng: 77.5833,
  summary: "Hemis in Ladakh is known for the Hemis Monastery and the annual Hemis Festival featuring masked dances and Buddhist rituals."
},
{
  name: "Coonoor, India",
  lat: 11.3500,
  lng: 76.8167,
  summary: "Coonoor is a scenic hill station near Ooty, known for tea gardens, rolling hills, and colonial charm."
},
{
  name: "Orchha, India",
  lat: 25.3510,
  lng: 78.6412,
  summary: "Orchha in Madhya Pradesh is a hidden gem with grand palaces, ancient temples, and a peaceful riverside setting."
},
{
  name: "Auroville, India",
  lat: 12.0055,
  lng: 79.8097,
  summary: "Auroville near Pondicherry is an experimental township promoting spiritual living, unity, and sustainable development."
},
{
  name: "Rishikesh, India",
  lat: 30.0869,
  lng: 78.2676,
  summary: "Rishikesh in Uttarakhand is a yoga capital of the world, also popular for river rafting, Ganga aarti, and spiritual retreats."
},
{
  name: "Bhedaghat, India",
  lat: 23.1094,
  lng: 79.8314,
  summary: "Bhedaghat near Jabalpur is known for its stunning marble rocks, Dhuandhar Falls, and boat rides on the Narmada river."
},
{
  name: "Khajuraho, India",
  lat: 24.8318,
  lng: 79.9199,
  summary: "Khajuraho in Madhya Pradesh is a UNESCO site known for its exquisite erotic temples and stunning stone carvings."
},
{
  name: "Gwalior, India",
  lat: 26.2183,
  lng: 78.1828,
  summary: "Gwalior in Madhya Pradesh is rich in history with its massive fort, royal palaces, and classical music tradition."
},
{
  name: "Mawlynnong, India",
  lat: 25.2000,
  lng: 92.0167,
  summary: "Mawlynnong in Meghalaya is acclaimed as Asia’s cleanest village, surrounded by living root bridges and lush greenery."
}
];

export default manualCities;
